export const fallbackEvents = [
  {
    id: 1,
    slug: "soulful-teej-yatra-usa-tour-2025",
    image: "/images/ad.jpg",
    title: "Soulful Teej Yatra: USA Tour 2025",
    category: "performances",
    description:
      "An unforgettable celebration of Nepali culture featuring Asmita Adhikari and Mahesh Kafle on tour across the USA.",
    status: "past",
    event_date: "2025-09-01T19:00:00",
  },
  {
    id: 2,
    slug: "aba-hami-uthnechau",
    image: "/images/6p.jpg",
    title: "Aba Hami Uthnechau",
    category: "entertainment",
    description:
      "An exciting cultural event featuring the Chakka Panja Team with amazing performances and entertainment.",
    status: "past",
    event_date: "2025-08-01T19:00:00",
  },
  {
    id: 3,
    slug: "hitai-ko-maya-umrika-tour-2025",
    image: "/images/njktour.jpg",
    title: "Hitai Ko Maya Umrika Tour 2025",
    category: "performances",
    description:
      "An unforgettable musical journey with NJK Tour bringing Nepali music to audiences across America.",
    status: "past",
    event_date: "2025-07-01T19:00:00",
  },
  {
    id: 4,
    slug: "dashain-tihar-fest-2024",
    image: "/images/tys06523.webp",
    title: "Dashain Tihar Fest 2024",
    category: "festivals",
    description:
      "A vibrant celebration of Nepalese culture, music, and food with thousands of attendees.",
    facebook_album_url: "https://www.facebook.com/media/set/?set=a.878298401003629&type=3",
    status: "past",
    event_date: "2024-10-01T19:00:00",
  },
  {
    id: 5,
    slug: "1974-ad-concert",
    image: "/images/1974.jpg",
    title: "1974 A.D Concert",
    category: "performances",
    description: "Legendary band 1974 A.D live in concert, uniting generations through music.",
    facebook_album_url: "https://www.facebook.com/media/set/?set=a.878298401003629&type=3",
    status: "past",
    event_date: "2024-09-01T19:00:00",
  },
  {
    id: 6,
    slug: "melody-night",
    image: "/images/m-night.jpg",
    title: "Melody Night",
    category: "entertainment",
    description:
      "Nepali melody night showcasing top Nepali vocalists and musicians, filled with enchanting tunes and soulful performances.",
    status: "past",
    event_date: "2024-05-01T19:00:00",
  },
  {
    id: 7,
    slug: "aba-haascha-virginia",
    image: "/images/ab-va2.jpg",
    title: "Aba Haascha Virginia",
    category: "festivals",
    description: "Nepali comedy show featuring top Nepali comedians, filled with laughter and fun.",
    facebook_album_url: "https://www.facebook.com/media/set/?set=a.801340362032767&type=3",
    status: "past",
    event_date: "2023-11-01T19:00:00",
  },
  {
    id: 8,
    slug: "dashain-tihar-fest-2023",
    image: "/images/dt23.jpg",
    title: "Dashain Tihar Fest 2023",
    category: "exhibitions",
    description:
      "A vibrant celebration of Nepalese culture, music, and food with thousands of attendees.",
    facebook_album_url: "https://www.facebook.com/media/set/?set=a.725950009571803&type=3",
    status: "past",
    event_date: "2023-10-01T19:00:00",
  },
];

